import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';
import { Loader } from 'components/indicators/loader';
import { DeliverySettingsEditForm } from './partials';

export const DeliverySettingsEdit = () => {
  const params = useParams();
  const { id } = params;

  const { getById } = useContext(CompanyContext);
  const { state: auth } = useContext(AuthContext);
  const [itemData, setItemData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const findItemById = async (itemId) => {
      setLoading(true);
      const getItemResponse = await getById({
        collectionName: Config.DATA.COLLECTIONS.DELIVERY_SETTINGS,
        token: auth.token,
        id: itemId,
        excludeCulture: true,
      });

      if (getItemResponse) {
        setItemData(getItemResponse);
      }

      setLoading(false);
    };

    if (id) {
      findItemById(id);
    }

    return () => {
      setItemData(null);
    };
  }, [id, auth.token]);

  if (loading) {
    return <Loader />;
  }

  return <DeliverySettingsEditForm itemData={itemData} isEdit />;
};
